import { Account } from '@frontend/account/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';

interface ViewProps {
    onChangeMembership: (value: string | null) => void;
    accounts: Account[];
    selectedAccount: Account | null;
    isSwitching: boolean;
}

const useAccountMembership = (): ViewProps => {
    const accountInfo = useAccountRepository();
    const accounts = useMemo(() => accountInfo.store.availableAccountsInfo, [accountInfo.store.availableAccountsInfo]);
    const [selectedAccount, changeSelectedAccount] = useState<Account | null>(null);
    const [isSwitching, setIsSwitching] = useState(false);

    useEffect(() => {
        const next = accounts.find((acc) => acc.id === accountInfo.store.currentAccount) ?? null;
        changeSelectedAccount((prev) => (prev?.id === next?.id ? prev : next));
    }, [accountInfo.store.currentAccount, accounts]);

    const onChangeMembership = async (value: string | null) => {
        if (!value || isSwitching || value === accountInfo.store.currentAccount) {
            return;
        }
        setIsSwitching(true);
        try {
            await accountInfo.updateCurrentAccount(value);
            window.location.reload();
        } catch {
            setIsSwitching(false);
        }
    };

    return {
        onChangeMembership,
        selectedAccount,
        accounts,
        isSwitching
    };
};

export default useAccountMembership;
